import type { ReactNode } from 'react'

import styled from 'styled-components'

import {
  Avatar,
  Button,
  Dropdown,
  Icon,
  Layout,
  SideNavigation,
  Text,
  TopNavigation,
} from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-tokens'

import useOauth2Flow from 'auth/ui/hooks/useOauth2'
import { useSession } from 'auth/ui/hooks/useSession'
import { signOut } from 'core/utils/signout'

export const TitleContainer = styled.div`
  flex: 1;
  margin-right: ${getToken('spacing-2')};
`

export const ActionsContainer = styled.div`
  margin: 0 ${getToken('spacing-2')};
  display: none;

  @media screen and (min-width: ${getToken('media-screen-desktop')}) {
    display: flex;
  }
`

type HeaderProps = {
  title?: ReactNode
  actions?: ReactNode
  unauthCtaLabel?: string
  unauthCtaHref?: string
}

export default function Header({ title, actions, unauthCtaLabel, unauthCtaHref }: HeaderProps) {
  const session = useSession()

  const { logOut } = useOauth2Flow()

  return (
    <TopNavigation>
      <SideNavigation.Trigger />
      {title && <TitleContainer>{title}</TitleContainer>}
      {actions && <ActionsContainer>{actions}</ActionsContainer>}
      <div style={{ height: '40px' }} />
      {session ? (
        <Dropdown>
          <TopNavigation.Item>
            <Avatar name={shortenName(`${session.user.first_name} ${session.user.last_name}`)} />
          </TopNavigation.Item>
          <Dropdown.Menu>
            <Dropdown.Item
              leading={
                <Avatar
                  name={shortenName(`${session.user.first_name} ${session.user.last_name}`)}
                  size="24"
                />
              }
            >
              <Layout.Stack gap="none">
                <Text variant="body-md-bold" color="color-text-primary">
                  {`${session.user.first_name} ${session.user.last_name}`}
                </Text>
                <Text variant="body-sm" color="color-text-placeholder">
                  {session.user.email}
                </Text>
              </Layout.Stack>
            </Dropdown.Item>
            <Dropdown.Item
              leading={
                <Layout.Box paddingX="spacing-1" paddingY="none">
                  <Icon name="log-out" />
                </Layout.Box>
              }
              onClick={async () => {
                await signOut()
                logOut()
              }}
            >
              <Text variant="body-md-bold" color="color-text-primary">
                Logout
              </Text>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Button size="small" href={unauthCtaHref ?? "/login"}>
          {unauthCtaLabel ?? "Sign in with Loadsmart"}
        </Button>
      )}
    </TopNavigation>
  )
}

function shortenName(name: string) {
  return name.split(' ').slice(0, 2).join(' ')
}
